import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, space, fontSizes, lineHeights } = theme

export const List = styled.ol`
  font-size: ${fontSizes['font-size-body-2']};
  color: ${colors['neutral-text-weak']};
  line-height: ${lineHeights['font-line-height-lg']};
  padding-left: ${space['spacing-sm']};
  margin-bottom: ${space['spacing-sm']};
`